import type { HTTPService } from "@soft-db/http";
import type { UserScope } from "./user-api";

export type ExternalRecipient = {
	id: string;
	name: string;
	notes: string;
	email: string;
	phoneNumber: string;
	scope: UserScope;
};

export class ExternalRecipientApi {
	constructor(private _http: HTTPService) {}

	async fetchByDist(dist: string) {
		return await this._http.get<ExternalRecipient[]>(`/distributors/${dist}/external-recipients`);
	}

	async fetchBySpace(space: string) {
		return await this._http.get<ExternalRecipient[]>(`/spaces/${space}/external-recipients`);
	}

	async fetchById(id: string) {
		return await this._http.get<ExternalRecipient>(`/external-recipients/${id}`);
	}
}
